/** @file Label - Renders the field's primary label. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as constants from '../constants';
import { injectFieldContext, useFieldContextValue } from '../context';
/** Label component takes the ID in the context and renders a decent <label> for a form control element. */
export const Label = tsx.component({
    name: constants.nameLabel,
    inject: injectFieldContext(),
    computed: useFieldContextValue(),
    props: {
        labelClass: p.ofType().default('label-large'),
        for: p(String).optional,
        alignment: p.ofStringLiterals('center', 'top').default('center'),
    },
    /** @returns Results of render function. */
    render() {
        return (<label for={this.for ?? this.fieldContext.inputId} class={[
                constants.nameLabel,
                this.labelClass,
                { 'self-start mt-1': this.alignment === 'top' },
            ]}>
                {this.$slots.default}
            </label>);
    },
});
